export const hasQualified = (qualified?: number) => {
  return qualified && qualified !== 8001;
};

export const isQualified = (qualified?: number) => {
  return qualified === 8002;
};

export const isQualifiedPro = (qualified?: number) => {
  return qualified === 8003;
};
